<template>
    <div>
        <button type="button" class="btn btn-blue btn-browse" @click="reset"><i class="fa fa-bars" aria-hidden="true"></i> <i class="fa fa-times" aria-hidden="true"></i> Browse <span class="hidden-xs">Categories</span></button>
        <slot v-if="!active"></slot>
        <template v-else>

            <nav class="categories mobile-categories" :class="{'active': active }">
                <div class="nav-item top-level back" v-if="parent">
                    <a href="#" @click.prevent="goBack"><span><i class="fa fa-angle-left" aria-hidden="true"></i> Back</span></a>
                </div>
                <ul itemscope itemtype="http://www.schema.org/SiteNavigationElement">
                    <li itemprop="name" class="nav-item top-level" :class="{ 'promotion-link' : category.promotional }" v-for="category in current" :key="category.id">
                        <a itemprop="url" :href="url(category)" title="Go to" @click.prevent="goInto(category)">
                            <span>{{ category.name }}</span>
                            <template v-if="category.children && category.children.length">
                                <i class="fa fa-angle-right"></i>
                            </template>
                        </a>
                    </li>
                    <!-- <li itemprop="name" class="nav-item top-level promotion-link" key="monthly-promotions">
                        <a href="/monthly-promotions" itemprop="url" title="Go to Monthly Promotions">
                            <span>Monthly Promotions</span>
                        </a>
                    </li>
                    <li itemprop="name" class="nav-item top-level promotion-link" key="powertoll-promotions">
                        <a href="/power-tool-promotions" itemprop="url" title="Go to Power Tool Promotions">
                            <span>Power Tool Promotions</span>
                        </a>
                    </li> -->
                </ul>
            </nav>
        </template>

        <slot name="buttons"></slot>
        <div class="nav-overlay active" v-if="active" @click="reset"></div>
    </div>
</template>

<script>
    import Categories from '../Services/Categories.js';
    export default {
        data() {
            return {
                active: false,
                previous: null,
                parent: null,
                current: null,
                original: null,
                parent: null,
                windowWidth:0,
            };
        },
        mounted() {
            Categories.getTree().then(response => {
                this.current = response.data;
                this.original = response.data;

                this.original.push({
                    id: 'monthly-promotions',
                    slug: 'monthly-promotions',
                    promotional: true,
                    children: [],
                    name: 'Monthly Promotions'
                });

                this.original.push({
                    id: 'power-tool-promotions',
                    slug: 'power-tool-promotions',
                    promotional: true,
                    children: [],
                    name: 'Power Tool Promotions'
                });
            });

            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth()
            });
        },
        watch: {
            windowWidth() {
                if (this.windowWidth > 990) {
                    this.active = false;
                }
            },
        },
        methods: {
            disable() {
                if (this.active) {
                    this.active = false;
                }
            },
            url(category) {
                if (category.promotional) {
                    return '/' + category.slug;
                }
                return '/categories/' + category.slug;
            },
            goInto(category) {
                if (!category.children || !category.children.length) {
                    window.location = this.url(category);
                    return;
                }

                // Set previous as current.
                const current = this.current; // Makes non reactive.
                this.previous = current;

                // Set parent as clicked
                this.parent = category;

                // Set current as children
                this.current = category.children;
            },
            getWindowWidth(event) {
                this.windowWidth = document.documentElement.clientWidth;
            },
            goBack() {
                // this.parent = parent;
                this.current = this.previous;

                // Find the ID of the parent and their parent,
                // we need to stay 2 levels deep.
                if (this.parent.parent_id) {
                    let parent = this.findParent(this.parent.parent_id, this.original);
                    this.parent = parent;

                    // console.clear();
                    // Now find previous...
                    if (parent) {
                        let previous = this.findParent(parent.parent_id, this.original);
                        if (previous) {
                            this.previous = previous.children;
                        } else {
                            this.previous = this.original;
                        }
                    } else {
                        this.parent = null;
                        this.current = this.original;
                    }

                } else {
                    this.parent = null;
                }

            },
            findParent(id, object) {
                let parent = null;
                _.each(object, cat => {
                    if (cat.id == id) {
                        parent = cat;
                        return false;
                    }
                    parent = this.findParent(id, cat.children);
                    if (parent) {
                        return false;
                    }
                });

                return parent;
            },
            reset() {
                this.active = !this.active;
                this.current = this.original;
                this.parent = null;
                this.previous = null;
            }
        },
        props: {
            items: {
                type: Object|Array,
                default() {
                    return [];
                },
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/SiteNavigation.vue